import React, { useEffect, useRef, useState} from 'react';
import * as d3sc from 'd3-scale';
import RadialGraph from './RadialGraph';
import ImageButton from './graphImageButton';

/*
import SunburstGraph from './SunburstGraph';
import HorizontalTreeGraph from './HorizontalTreeGraph';
import HorizontalTreeMap from './HorizontalTreeMap';
import VerticalTreeMap from './VerticalTreeMap';
import VerticalTreeGraph from './VerticalTreeGraph';
import ForceDirectedGraph from './ForceDirectedGraph';
*/
import  './Graph.css';
import TimelineWithMiniMap from './TimelineMiniMap';

let protocol = process.env.REACT_APP_PROTOCOL
if (protocol === undefined){
      protocol = "http"
}

let server_host = process.env.REACT_APP_ALTAIEGO_HOST
if (server_host === undefined) {
  server_host = window.location.hostname
}

const Graph = ({ room, uid, username, channel, map_name, scrollMessages,
              pMessage, last_live_message_id, mmNodes, startDate, setStartDate, graphRatio, graphWidth, graphHeight,
              setMMNodes, mmLinks, setMMLinks,
              minThreshold, setMinThreshold, isOwner, isCoach, isMobile, hideTooltipWhenOut}) => {
  const [leadedMove, setLeadedMove] = useState(true)
  const [pointed_message, setPointed_message] = useState()
  const currentRoomRef = useRef(room)
  const [domain_matches, setDomain_matches] = useState(new Map())
  const [domain_corrections, setDomain_corrections] = useState(new Map())
  const [disp_matches, setDisp_matches] = useState([])
  const [disp_corrections, setDisp_corrections] = useState([])
  const [disp_dom_messages, setDisp_dom_messages] = useState([])
  const [nb_messages, setNbMessages] = useState(0)
  const map_domains = useRef([])
  const [graphFormat, setGraphFormat] = useState('@')
  const [formatList, setFormatList] = useState(['@', 'V', 'H', '->', 'VMap', 'HMap'])
  const [graphDepth, setGraphDepth] = useState('Carte')
  const [maxNbConcepts, setMaxNbConcepts] = useState(1)
  const [nb_domains, setNbDomains] = useState(4)
  const max_depth_menu_options = ['Carte', 'POI', 'Observation', 'Capteurs']
  const map_max_depth = useRef(2)
  const map_depth_menu_options = max_depth_menu_options.slice(0, map_max_depth.current - 1)
  const [depthList, setDepthList] = useState(map_depth_menu_options)
  const time_pondered_similarities = useRef({})
  const polarities = useRef({})
  const m_Nodes = useRef(mmNodes)
  const m_Links = useRef(mmLinks)
  const [maxThreshold, setMaxThreshold] = useState(1);
  const mapRef = useRef(domain_matches);
  const currentTargetMessage = useRef(null)
  const pointed_message_ref = useRef(pointed_message)
  const last_match_ref = useRef('')
    
  currentRoomRef.current = room

  if (mmNodes != undefined && mmNodes.fils !== undefined) {
      setNbDomains(mmNodes.fils.length)
  }
  pointed_message_ref.current = pointed_message

  // Fonction de mise à jour du seuil minimum
  const handleMinThresholdChange = (event) => {
    const newMinValue = parseFloat(event.target.value);
    // On s'assure que le minimum reste inférieur au maximum
    if (newMinValue < maxThreshold) {
      setMinThreshold(newMinValue);
    }
  };

  // Fonction de mise à jour du seuil maximum  
  const handleMaxThresholdChange = (event) => {
    const newMaxValue = parseFloat(event.target.value);
    // On s'assure que le maximum reste supérieur au minimum
    if (newMaxValue > minThreshold) {
      setMaxThreshold(newMaxValue);
    }
  };

  const match_window_size = 40


  function hasChanged(oldNode, newNode) {
    return oldNode.name !== newNode.name || oldNode.description !== newNode.description || oldNode.quality !== newNode.quality ||
                oldNode.tested !== newNode.tested || oldNode.passed !== newNode.passed;
  }

  function wrap_text(text, maxWidth=38, lineHeight=2) {
    const res = []
    const words = text.split(' ');
    let line = '';

    words.forEach((word, index) => {
        const testLine = line + word + ' ';

        if (testLine.length > maxWidth && index > 0) {
            res.push(line)
            line = word + ' '
        } else {
            line = testLine;
        }
    });
    if (line.length > 0)
      res.push(line)
    res.push('')

    return res
}

function request_a_form(d) {
  if ((! isOwner) || (! isCoach)) {
    return
  }
  const t = d.text
  const m_id = d.message_id
  const room = currentRoomRef.current
  const request = {t, m_id,  room, uid };
  channel.emit('creation form', request)
}

  function request_a_correction(d) {
    let m_id = pointed_message_ref.current
    if (m_id === undefined || m_id === null) {
      m_id = last_live_message_id
    }
    if (m_id === undefined || m_id === null || (! isOwner) || (! isCoach)) {
      return
    }

    const target_node = d.data.id
    let nickName = null
    let cur_d = d
    let path = []
    while (cur_d) {
      path.push(cur_d.data.name.replaceAll(' ', '_'))
      if (! nickName) {
        nickName = cur_d.data.nickName
      }
      cur_d = cur_d.parent
    }
    path = path.reverse()
    const target_path = path.join('/')
    const polarity = d.data.polarity

    const map_root = m_Nodes.current[0].name
    const room = currentRoomRef.current
    const request = {m_id, target_node, target_path, room, map_root, uid, nickName, polarity};
    channel.emit('correction form', request)
  }

const depths = ['gnu', 'Carte', 'POI',  'Observation', 'Capteurs']
const gdepth = depths.findIndex(d => d === graphDepth) + 1

function max_match_domain(matches_str, message_id, pointed = false){
  /*
  for (let key in time_pondered_similarities) {
    delete time_pondered_similarities[key][message_id];
  }
    */
  if (polarities.current[message_id] === undefined) {
    time_pondered_similarities.current[message_id] = {}
  }

  if (polarities.current[message_id] === undefined) {
    polarities.current[message_id] = {}
  }

  if (matches_str === undefined || matches_str.length === 0)
    return ''
  var matches = []
  // console.log(Object.prototype.toString.call(matches_str))
  // console.log(typeof matches_str)
  try { // new matching format
    matches_str.map((m) => {
      const sim = JSON.parse(m)
      matches.push(sim)
      return
    })
  } catch { // old matching format
    try {
      matches = JSON.parse(matches_str)
    } catch {
      matches = matches_str
    }

  }
 var max = 0.3
 for (var k in matches) {
    let val = matches[k]
    if (val.similarity === undefined) {  // compat ascendante, temporaire
        if (val.concept) {
          continue
        }
        if (val[0] >= max) {
          max = val[0]
        }
    } else {
      let time_factor = 1  // to be refined by the difference between now and the treated utterance
      try {
        const ts = val["utterance_id"].split("_").splice(-1)
        let start_ts =  Date.now()
        if (pointed_message)
          start_ts = parseFloat(pointed_message)
        time_factor = (start_ts / parseFloat(ts)) ** 0.01
      } catch {}
      const pondered_similarity = val.pondered_similarity
      const time_pondered_similarity = pondered_similarity //  / time_factor
      time_pondered_similarities.current[message_id][removeAfterLastUnderscore(val.domain).toLowerCase()] = time_pondered_similarity
      if (time_pondered_similarity >= max) {
        max = time_pondered_similarity
      }
      if (! pointed) {
         // continue
      }
      const items = JSON.parse(val['items'])
      var max_item_sim = 0
      var max_item_sim_id = undefined
      for (var i in items) {
        const item = items[i]
        // console.log('updating quality for ' + item)
        const psim = ((pondered_similarity * item.pondered_similarity) ** 0.5)/ time_factor
        time_pondered_similarities.current[message_id][item.id] = psim
        const tests = JSON.parse(item.similarity_tests)
        var max_test_sim = 0
        var max_test_sim_id = undefined
        for (var t in tests) {
          const test = tests[t]
          const source = mmNodes.find((cn) => removeAfterLastUnderscore(cn.id) === removeAfterLastUnderscore(test.id))
          const psim = ((pondered_similarity * test.pondered_similarity * item.pondered_similarity ) ** 0.33) / time_factor

          var polarity = 'positive'
          if ((source !== undefined) && (source.negative === 'true')) {
              polarity = 'negative'
          }
          if (test.pondered_similarity > max_test_sim) {
            max_test_sim = test.pondered_similarity
            max_test_sim_id = test.id
          }
          if (polarity === 'negative'){
            polarities.current[message_id][test.id] = polarity
            polarities.current[message_id][item.id] = polarity
            polarities.current[message_id][val.domain] = polarity
          }
          var max_check_sim = 0
          var max_check_sim_id = undefined

          const checks = JSON.parse(test.similarity_checks)

          // for (var c in checks) {
            //const check = checks[c]
            //var check_polarity = polarity
            //if (beginsWith(check.id, 'faible')) {
//              console.log('debug point')
            //}
            //if (polarity === 'positive') {
//              const source = mmNodes.find((cn) => removeAfterLastUnderscore(cn.id) === removeAfterLastUnderscore(check.id))
              //if ((source !== undefined) && (source.negative === 'true')) {
//                check_polarity = 'negative'
              //}
            //} else {
              //check_polarity = 'negative'
            //}
            //if (check.pondered_similarity > max_check_sim) {
//              max_check_sim = check.pondered_similarity
              //max_check_sim_id = check.id
            //}
  
            //const psim = ((pondered_similarity * check.pondered_similarity * test.pondered_similarity * item.pondered_similarity ) ** 0.25)/ time_factor
            //time_pondered_similarities.current[message_id][check.id] = psim
            //polarities.current[message_id][check.id] = check_polarity
          //}
          if ((polarity === 'positive') && (max_check_sim_id != undefined)){
            polarities.current[message_id][test.id] = polarities.current[message_id][max_check_sim_id]
          }
        }  
        if (max_test_sim_id != undefined) {
          polarities.current[message_id][item.id] = polarities.current[message_id][max_test_sim_id]
        }
        if (item.pondered_similarity > max_item_sim) {
          max_item_sim = item.pondered_similarity
          max_item_sim_id = item.id
        }
      }
      if (max_item_sim_id != undefined) {
        polarities.current[message_id][val.domain] = polarities.current[message_id][max_item_sim_id]
      } else {
        polarities.current[message_id][val.domain] = 'positive'
      }
    }
    if (!map_domains.current.includes(val.nickName)) {
      map_domains.current.push(val.nickName)
    }
  }
 return max
}


function removeAfterLastUnderscore(str) {
    const lastIndex = str.lastIndexOf('_');
    return lastIndex !== -1 ? str.substring(0, lastIndex) : str;
}


function finishesWith(str, suffix) {
    return str.slice(-suffix.length) === suffix;
}

function beginsWith(str, prefix) {
    return str.slice(0, prefix.length) === prefix;
}


function correction_to_display_in_domain(dom, m_corrections, curNodes) {
  const matching_messages = []
  const matching_concepts = {}
  const dom_id = removeAfterLastUnderscore(dom.id).toLowerCase()
  const c_entries = Array.from(m_corrections.entries())
  if (c_entries === undefined) {
    return [[], {}, []]
  }
  const corrections = c_entries.filter((e) => {
    const entry = e[1]
    const m_id = entry.message_id
    //const deformedValue = Math.sin(minThreshold * Math.PI / 2)

    // return (entry.strength > deformedValue) && finishesWith(removeAfterLastUnderscore(entry.target_node), removeAfterLastUnderscore(dom.id))  // temporary
    return (entry.strength > minThreshold) && finishesWith(removeAfterLastUnderscore(entry.target_node), removeAfterLastUnderscore(dom.id))  // temporary
  })

  corrections.map((last_correction) => {
 //       if (pointed) {
          // setPolarities({})
          const corrections_set = corrections.filter((c) => {
            return c[1].message_id === last_correction[1].message_id
          })
          if (corrections_set.length > 0){
            const lc = corrections_set[corrections_set.length - 1][1]
            if (lc._id !== last_correction[1]._id) {
              return  // forget about previous corrections, only the last one matters
            } else {
              const j = matching_messages.length
              let display_index = '(+' + lc.display_index + ') '
              if (lc.display_index === 0) {
                display_index = ''
              }
              if (lc.display_index > 0) {
                display_index = '(-' + lc.display_index + 1 +  ') '
              }
              let full_text = '(' + new Date(parseInt(lc.id)).toLocaleString('fr-FR', {"dateStyle": "medium", 
                      "timeStyle": "short"}) + ') ' + 
                       lc.message
              const lines = wrap_text(full_text)
              for (let i in lines) {
                const line = lines[i]
                // lines.map((line, i) => {
                const l_id = lc.target_node + '_' + j + '_' + i
                const in_messages = matching_messages.find(d =>  (d.id  === l_id))
                if (! in_messages) {
                  matching_messages.push({id : l_id, 
                              source : dom, 
                              message_id : lc.message_id,
                              text : line,
                              full_text : full_text.slice(0, 120), 
                              polarity : lc.polarity,
                              current_target : (lc.message_id === currentTargetMessage.current || 
                              lc.message_id === last_match_ref.current || 
                              lc.message_id == pointed_message),
                              w_idx : matching_messages.length})
                  }
                }
                //if (graphDepth !== 'Carte') {
                // then insert the concept in matching concepts
                const target = lc.target_node
                let target_node = curNodes.find((n) => removeAfterLastUnderscore(n.id) === removeAfterLastUnderscore(lc.target_node))
                if (target_node === undefined) {
                      return
                }
                let depth = target_node.depth
                let pres_depth = 5 
                if (graphDepth === 'POI') {
                  pres_depth = 3
                } else if (graphDepth === 'Observation') {
                  pres_depth = 4
                } else if (graphDepth === 'Carte') {
                  pres_depth = 2
                }
                while (depth > pres_depth) {
                    target_node = curNodes.find((n) => removeAfterLastUnderscore(n.id) === removeAfterLastUnderscore(target_node.parent))
                    depth = target_node.depth
                }
                if (target_node.id in matching_concepts) {
                    const j = matching_concepts[target_node.id].length
                    const cidx = 'concept_' + lc.message_id + '_' + j
                    const inEntries = matching_concepts[target_node.id].find((ec) => removeAfterLastUnderscore(ec.id) === removeAfterLastUnderscore(cidx))
                    const inMessages = matching_messages.find((m) => m.message_id === lc.message_id)
                    if (!inEntries && inMessages){
                        matching_concepts[target_node.id].push(
                          {id : cidx, 
                          source : target_node, 
                          message_id : lc.message_id,
                          display_index : display_index,
                          text : lc.concept, 
                          path : lc.target_path,
                          polarity : lc.polarity,
                          current_target :(lc.message_id === currentTargetMessage.current || 
                                            lc.message_id === last_match_ref.current || 
                                            lc.message_id == pointed_message),
                          w_idx : matching_concepts[target_node.id].length})
                    }
                  } else {
                    const j = 0
                    matching_concepts[target_node.id] = [
                      {id : 'concept_' +  lc.message_id + '_' + j, 
                      source : target_node, 
                      message_id : lc.message_id ,
                      polarity : lc.polarity,
                      display_index : display_index,
                      text : lc.concept, 
                      path : lc.target_path,
                      current_target : (lc.message_id === currentTargetMessage.current || 
                                        lc.message_id === last_match_ref.current || 
                                        lc.message_id == pointed_message),
                      w_idx : 0}
                    ]
                  }
              target_node = curNodes.find((n) => removeAfterLastUnderscore(n.id) === removeAfterLastUnderscore(lc.target_node))
              time_pondered_similarities.current[lc.message_id] = {}
              try {
                let polarity = lc.polarity
                if (polarities.current[lc.message_id] === undefined) {
                  polarities.current[lc.message_id] = {}
                }
              while (target_node && target_node.id !== dom.id) {
                  const m = polarities.current[lc.message_id]
                  const target_node_id = removeAfterLastUnderscore(target_node.id).toLowerCase()
                  m[target_node_id] = polarity
                  time_pondered_similarities.current[lc.message_id][target_node_id] = lc.strength
                  target_node = mmNodes.find((n) => {
                    return beginsWith(n.id, target_node.parent)
                  })
              }
              const target_node_id = removeAfterLastUnderscore(target_node.id).toLowerCase()
              polarities.current[lc.message_id][target_node_id] = polarity
          } catch (e){
            console.log(e)
          }
        time_pondered_similarities.current[lc.message_id][dom_id] = last_correction[1].strength
        //}
        } 
      }
    });
  return [matching_messages, matching_concepts]
}


function match_to_display_in_domain(match_str, dom, pointed) {
  var match = match_str
  try {
      match = JSON.parse(match_str)
  } catch {}
  const dom_id = removeAfterLastUnderscore(dom.id).toLowerCase()  
    let res = false

    const max = max_match_domain(match.matched_domains, match.id, pointed)
    try {
      const dom_match = match.matched_domains.find( m => removeAfterLastUnderscore(m.domain).toLowerCase() === dom_id)
      if (dom_match){
        // const d_match = JSON.parse(dom_match)
        const diff = max - time_pondered_similarities.current[match.id][dom_id]
        if (diff < 0.002){
          // const deformedValue = Math.sin(minThreshold * Math.PI / 2)
          // res = max > deformedValue
          res = max > minThreshold
        }
      } 
    } catch {
      if (match.matched_domains.hasOwnProperty(dom.id)) {
        const diff = max - match.matched_domains[dom.id][0]
        if (diff < 0.5){
          res = true
        }
      }
    }
  return res
}

function match_to_display_in_domain_item(match_str, dom, j, pointed, m_messages, curNodes,
          m_corrections, matching_concepts) {
  var match = match_str
  try {
      match = JSON.parse(match_str)
  } catch {}
  const dom_id = removeAfterLastUnderscore(dom.id)

  let res = false
  try {
    const item_match = match.matched_domains.find( (m) => {
      return m.concept !== undefined
  })
    if (item_match !== undefined && 
      finishesWith(removeAfterLastUnderscore(item_match.item_id), dom_id)){
      res = true
    } 
  } catch (ex) {
    return res
  }
    return res
}

function select_matches_window(matching_messages, pointed_message) {
  let max_nb = (graphRatio * 10 * 4) / (gdepth * nb_domains)
  let last_index_to_display = matching_messages.length - 1
  matching_messages.map((m, i) => {
    if (m.message_id === pointed_message) {
      last_index_to_display = i
    }
  })
  if (last_index_to_display < max_nb - 1) {
    return matching_messages.slice(0, max_nb)
  } else {
    return matching_messages.slice(last_index_to_display - ( 2 * max_nb / 3), last_index_to_display + max_nb / 3)
  }
}

function domain_matches_to_nodes(curNodes, matches, corrections){
  const disp_texts = []

  if (curNodes === undefined || (matches === undefined && corrections == undefined))
    return []
  for (let id in curNodes){
    const d = curNodes[id]
    if (d.depth === 2) {
      /*
        corrections display first
      */
      let matches_by_correction = correction_to_display_in_domain(d, corrections, curNodes) 
      const matching_messages = matches_by_correction[0]
      // const matching_messages = []
      // const matching_concepts = {}
      const matching_concepts = matches_by_correction[1]

      // console.log('low_corrections ' + low_corrections.length)
      //console.log('minThreshold ' + minThreshold + ' domain ' + d.id)

      for (let j in matches){
        const match = matches[j]

      // matches.map((match, j) => {
        if (match.matched_domains === undefined || match.matched_domains.length === 0) {
          continue
        }
        const corrected_match = corrections.find((c) => {
           return c.message_id === match.id
      })
        if (corrected_match !== undefined) { // do not display matches when correction
          continue
        }

        try {
            const md = []
            match.matched_domains.map((mdi) => {
              try {
                md.push(JSON.parse(mdi))
              } catch {
                md.push(mdi)
              }
            })
            match.matched_domains = md
        } catch {}

        //if (match.matched_domains.hasOwnProperty(d.id)) {
          if (match_to_display_in_domain(match, d, match.current_target)) {
            let display_index = '(+' + -match.display_index + ')'
            if (match.display_index === 0) {
              display_index = ''
            }
            if (match.display_index > 0) {
              display_index = '(-' + match.display_index + ')'
            }
            const time_as_date = new Date(parseInt(match.id)).toLocaleString('fr-FR', {"dateStyle": "medium", 
                      "timeStyle": "short"}) 

            const full_text = '[' + match.origin + '] ' + time_as_date + ' : ' + (match.message ? match.message : match.content)
            const lines = wrap_text(full_text)
            for (let i in lines) {
              const line = lines[i]
              if (line.trim().length == 0 ) {
                continue
              }
              // lines.map((line, i) => {
              const l_id = d.id + '_' + j + '_' + i
              const in_messages = matching_messages.find(d =>  (d.id  === l_id))
              if (! in_messages) {
                matching_messages.push({id : l_id, 
                  source : d, 
                  message_id : match.id,
                  text : line, 
                  full_text : full_text, 
                  current_target : match.current_target, 
                  w_idx : matching_messages.length})
                }
            }
          
            if (match_to_display_in_domain_item(match, d, j,  match.current_target, matching_messages,
              curNodes, corrections, matching_concepts)) {
              // match.matched_domains.map((m) => {
              for (let m in match.matched_domains){
                let match_entry = match.matched_domains[m]
                try {
                  match_entry = JSON.parse(match_entry)
                } catch {}
                let concept = match_entry.concept
                if (concept !== null && concept !== undefined) {
                  let target_node_id = match_entry.item_id
                  let target_node = curNodes.find((n) => removeAfterLastUnderscore(n.id) === removeAfterLastUnderscore(target_node_id))
                  if (target_node === undefined) {
                    continue
                  }
                  let depth = target_node.depth
                  let pres_depth = 5 
                  if (graphDepth === 'POI') {
                    pres_depth = 3
                  } else if (graphDepth === 'Observation') {
                    pres_depth = 4
                  } else if (graphDepth === 'Carte') {
                    pres_depth = 2
                  }
                  while (depth > pres_depth) {
                    target_node = curNodes.find((n) => removeAfterLastUnderscore(n.id) === removeAfterLastUnderscore(target_node.parent))
                    depth = target_node.depth
                  }
                  target_node_id = target_node.id

                  if (finishesWith(removeAfterLastUnderscore(target_node_id), removeAfterLastUnderscore(d.id))){
                    const source = curNodes.find((cn) => removeAfterLastUnderscore(cn.id) === removeAfterLastUnderscore(target_node_id))
                    const tl = match_entry.concept.trim().length
                    if (source !== undefined && tl > 0) {
                      const matching_concept_entries = Object.entries(matching_concepts)
                      const versioned_target_node_id = matching_concept_entries.find(([k,v]) => removeAfterLastUnderscore(k) ===removeAfterLastUnderscore(target_node_id))
                      if (versioned_target_node_id) {
                      const cidx = 'concept_' + match_entry.utterance_id + '_' + j
                      const inEntries = matching_concepts[versioned_target_node_id[0]].find((ec) => ec.id === cidx)
                      const inMessages = matching_messages.find((m) => m.message_id === match_entry.utterance_id)
                      if (!inEntries && inMessages){
                        matching_concepts[versioned_target_node_id[0]].push({id : cidx, 
                        source : source, 
                        message_id : match_entry.utterance_id,
                        display_index : display_index,
                        text : match_entry.concept, 
                        path : removeAfterLastUnderscore(match_entry.item_id).split('_').join('/'),
                        current_target : match.current_target, 
                        w_idx : matching_concepts[versioned_target_node_id[0]].length})
                      }
                    } else {
                      matching_concepts[target_node_id] = [{id : 'concept_' +  match_entry.utterance_id + '_' + j, 
                        source : source, 
                        message_id : match_entry.utterance_id,
                        display_index : display_index,
                        text : match_entry.concept, 
                        path : removeAfterLastUnderscore(match_entry.item_id).split('_').join('/'),
                        current_target : match.current_target, 
                        w_idx : 0}]
                    }
                  }
                }
              }
            }
          }
        }
      }
      // order matching_messages on their message_id
      const o_m_messages = matching_messages.sort((a, b) => {
          const a_id = parseInt(a.message_id, 10)
          const b_id = parseInt(b.message_id, 10)
          return a_id - b_id
      })

      // let match_res = o_m_messages.slice(-12) // reduce the number of message lines displayed on each domain
      // if (pointed_message && pointed_message !== '') {
      let match_res = select_matches_window(o_m_messages, pointed_message)
      // }

      if (match_res.length > 0) {
        match_res.map((o_m, i) => {
          o_m.w_idx = i
        })
        const first_index = match_res[0].w_idx
        // match_res.map((mm) => {
        for (let imm in match_res) {
          const mm = match_res[imm]
          mm.w_idx = mm.w_idx - first_index
          const in_disp = disp_texts.find(d => beginsWith(mm.id, d.id))
          const in_res = match_res.find(d => beginsWith(mm.id, d.id))
          if (in_disp) {
             if  (!(in_res)){
              disp_texts.remove(mm)
             }
          } else if (in_res) {
             if (!(in_disp)) {
              disp_texts.push(mm) 
              }
           }
        }

      for (let key in matching_concepts) {  // add to displayed lines three max concepts per item
          const i_matches = matching_concepts[key]
          //i_matches.map((im, i) => {
          let si_matches = i_matches.sort((a, b) => {
            const a_i = parseInt(a.message_id)
            const b_i = parseInt(b.message_id)
            return a_i - b_i
          })

          const max_nb_concepts_per_node = maxNbConcepts  // Math.floor(5 / (gdepth / 2))
          let ssi_matches = si_matches.filter(a => (startDate == null || parseInt(a.message_id) >= startDate) &&
                      (pointed_message == '' || pointed_message == null || parseInt(a.message_id) <= pointed_message)).slice(- max_nb_concepts_per_node)
          ssi_matches.map((im, i) => {
              im.w_idx = i
              disp_texts.push(im)
            })
        }

      }
      // return [{source: d, text: 'ceci est la ligne1'}, {source: d, text:'ligne2'}] // test case
    }
  }
return disp_texts
}
/*
function selectMatchesUpTo(m, cur_matches = domain_matches) {
  const res = []
  currentTargetMessage.current = pointed_message
  const sortedMatchEntries = Array.from(cur_matches.entries()).sort((a, b) => a[0] - b[0])
  if ((m === null) || (m === '') || (m === undefined)){
    for (let i in sortedMatchEntries){
//  sortedMatchEntries.map((mm) => {
       const mm = sortedMatchEntries[i][1]
       if (mm.roomId === currentRoomRef.current) {
        mm.current_target = false
        // if (mm.matched_domains.length > 0){
          res.push(mm)
        // }
      }
    }

    if (res.length > 0) {
      const last = res.pop()
      if ((pointed_message == null)  && (last_live_message_id === last.id)) {
        last.current_target = true
        currentTargetMessage.current = last_live_message_id
        // if (last.matched_domains.length == 0) {
        //   time_pondered_similarities.current = {}
        // }
      }
      // currentTargetMessage.current = last.matched_domains.length > 0
      res.push(last)
    }
    return res // .slice(- match_window_size)
  }

// there begins the code when a pointed message
  let id_toCheckWith = m.message_id
  if (id_toCheckWith === undefined) { // the case of reinit from the matches, not from the spans
    id_toCheckWith = m
  }
  var top = false
  var nb_more = 2
  sortedMatchEntries.map((mm) => {
    if ((m === undefined) || (id_toCheckWith >= mm[1].id)) {
      mm[1].current_target = false
      if (m !== undefined) {
        if (id_toCheckWith === mm[1].id) {
          top = true
          mm[1].current_target = true
          currentTargetMessage.current = mm[1]
        }
      }
      res.push(mm[1])

    } else if (top && nb_more > 0) {
          nb_more -= 1
          mm[1].current_target = false
          res.push(mm[1])
    }
  });
  return res // .slice(- match_window_size);
}
*/

function dispatch_corrections_matches(selected_ids, corrections, matches){
  const res_corrections = []
  const res_matches = []
  const nb_plus = 2
  
  let offset = selected_ids.indexOf(currentTargetMessage.current)
  if (offset === -1) {
    offset = selected_ids.length - 1
  }
  const index_0 = selected_ids.length - offset
  selected_ids.map((m_id, i) => {
    const c = corrections.entries().find((c) => c[1].message_id === m_id)
    if (c !== undefined) {
      const corr = c[1]
      if (corr.roomId !== currentRoomRef.current) return
      corr.display_index = offset - i
      corr.current_target = corr.current_target || corr.message_id === last_match_ref.current
      res_corrections.push(corr)
    } else {
      const m = matches.entries().find((m) => m[1].id == m_id)
      if (m !== undefined) {
        const match = m[1]
        if (match.roomId !== currentRoomRef.current) return
        match.display_index = offset - i
        match.current_target = match.current_target || match.id === last_match_ref.current
        res_matches.push(match)
      }
    }
  })
  return [res_corrections, res_matches]
}

function selectLastMessagesOrCorrections(m, cur_matches = domain_matches, cur_corrections = domain_corrections){
  
  const sortedCorrectionEntries = Array.from(cur_corrections.entries()).sort((a, b) => a[0] - b[0])
  const res = []
  // const deformedValue = Math.sin(minThreshold * Math.PI / 2)

  for (let i in sortedCorrectionEntries){
//  sortedMatchEntries.map((mm) => {
       const mm = sortedCorrectionEntries[i][1]
       if (startDate != null && parseInt(mm.id) < startDate) continue
       // if (mm.roomId === currentRoomRef.current) {
        mm.current_target = false
//         if (mm.strength > deformedValue) {
        if (mm.strength > minThreshold) {
          res.push(mm.message_id)
       //  }
       }
    }

  const sortedMatchEntries = Array.from(cur_matches.entries()).sort((a, b) => a[0] - b[0])
    for (let i in sortedMatchEntries){
//  sortedMatchEntries.map((mm) => {
       const mm = sortedMatchEntries[i][1]
       if (startDate != null && parseInt(mm.id) < startDate) continue

       if (mm.roomId === currentRoomRef.current) {
        mm.current_target = false
        if (! res.includes(mm.id)){

          if (mm.matched_domains !== undefined && mm.matched_domains !== null &&
//            mm.matched_domains.length > 0 && mm.matched_domains[0]['pondered_similarity']> deformedValue) {
            mm.matched_domains.length > 0 && mm.matched_domains[0]['pondered_similarity'] > minThreshold) {
            res.push(mm.id)
          }
        }
      }
    }
    // here we have all the index of corrections or matches
    if (res.length > 0) {
      res.sort()
      const last = res.pop()
      if ((pointed_message == null)  && (last_live_message_id === last)) {
        // last.current_target = true
        currentTargetMessage.current = last_live_message_id
        // if (last.matched_domains.length == 0) {
        //   time_pondered_similarities.current = {}
        // }
      }
      // currentTargetMessage.current = last.matched_domains.length > 0
      res.push(last)
    }
        
    if (res.length > 0){
      const lmatch = res[res.length - 1]
      last_match_ref.current = lmatch
    }

    const selected_messages_ids = res // .slice(- match_window_size)
    return dispatch_corrections_matches(selected_messages_ids, domain_corrections, domain_matches)
}


function selectMatchesOrCorrectionsUpTo(m, cur_matches = domain_matches, cur_corrections = domain_corrections) {

  // map_domains.current = []
  if ((m === null) || (m === '') || (m === undefined)){
    return selectLastMessagesOrCorrections(m, cur_matches = domain_matches, cur_corrections = domain_corrections)
  }

  last_match_ref.current = ''
  const res = []
  const suite = []
  currentTargetMessage.current = pointed_message
//  const deformedValue = Math.sin(minThreshold * Math.PI / 2)

// there begins the code when a pointed message
  let id_toCheckWith = m
  if (id_toCheckWith === undefined) { // the case of reinit from the matches, not from the spans
    id_toCheckWith = m
  }
  var top = false
  const nb_plus = 0
  var nb_more = nb_plus
  const sortedCorrectionEntries = Array.from(cur_corrections.entries()).sort((a, b) => a[0] - b[0])
  for (let i in sortedCorrectionEntries){
//  sortedMatchEntries.map((mm) => {
       const mm = sortedCorrectionEntries[i][1]
       if (startDate != null && parseInt(mm.id) < startDate) continue

       if (mm.roomId === currentRoomRef.current) {
          mm.current_target = mm.message_id === id_toCheckWith
          if (mm.current_target) {
            currentTargetMessage.current = mm.message_id
            top = true
          }
          if (mm.message_id <= id_toCheckWith) {
              // if (mm.strength > deformedValue) {
              if (mm.strength > minThreshold) {
                res.push(mm.message_id)
              }
          } else  if (top && nb_more > 0){
            // if (mm.strength > deformedValue) {
            if (mm.strength > minThreshold) {
              suite.push(mm.message_id)
              nb_more = nb_more - 1
            }
          }
        }
       }
  var top = false
  var nb_more = nb_plus
  const sortedMatchEntries = Array.from(cur_matches.entries()).sort((a, b) => a[0] - b[0])
  for (let i in sortedMatchEntries){
//  sortedMatchEntries.map((mm) => {
       const mm = sortedMatchEntries[i][1]
        if (startDate != null && parseInt(mm.id) < startDate) continue

        if (mm.matched_domains === undefined || mm.matched_domains.length === 0) {
            continue
        }
        if (mm.roomId === currentRoomRef.current) {
          mm.current_target = mm.id === id_toCheckWith
          if (mm.current_target) {
            top = true
            currentTargetMessage.current = mm.id
          }
         const mmm = mm.matched_domains[0]
          if (mm.id <= id_toCheckWith && (! res.includes(mm.id))) {
            // if (mmm['pondered_similarity'] > deformedValue){
            if (mmm['pondered_similarity'] > minThreshold){
              res.push(mm.id)
            }
          } else if (top && nb_more > 0 && (! res.includes(mm.id))){
            // if (mmm['pondered_similarity'] > deformedValue){
            if (mmm['pondered_similarity'] > minThreshold){
              suite.push(mm.id)
              nb_more = nb_more - 1
            }
          }
        } 
    }
    // here we have all the index of corrections or matches
    if (res.length > 0) {
      res.sort()
      if (suite.length > 0) {
        suite.sort()
        const m_plus = suite.slice(0, nb_plus)
        m_plus.map((s) => {
          res.push(s)
        })
      }
    }

    const selected_messages_ids = res // .slice(- match_window_size)
    return dispatch_corrections_matches(selected_messages_ids, domain_corrections, domain_matches)
}
      
function updatePointedMessage(message_id) {
  if (!isCoach) {
    return
  }
  setPointed_message(pMessage)
  pointed_message_ref.current = pMessage
}

useEffect(() => {
  updatePointedMessage(pMessage)
    // if pointed_message has no matches reset polarities and time_ponderations
  
  // const pointed_match = domain_matches.entries().find((m) => m == pMessage)
  // if (pointed_match === undefined){
  //  time_pondered_similarities.current = {}
  // }

},[domain_matches, pMessage])


useEffect(() => {


  function same_first(s1, s2) {
    let res = false
    if (s1.length === 0 && s2.length === 0) {
      return true
    }
    if (s1[0].id === s2[0].id) {
      res = true
    }
    return res
  }
  
  function same_last(s1, s2) {
      let res = false
      const last_index = s1.length -1
      if (last_index >= 0) {
        if (s1[last_index].id === s2[last_index].id) {
          res = true
        }
      }
      return res
  }
        
  function different_matches_set(s1, s2) {
        let res = true
        if (s1.length === s2.length && same_first(s1, s2) && same_last(s1, s2)) {
          res = false
        }
      
    return res
  }
  
   const c_or_m = selectMatchesOrCorrectionsUpTo(pointed_message)
  // if (different_matches_set(dMatches, disp_matches)) {
    setDisp_corrections([...c_or_m[0]])
    setDisp_dom_messages([...c_or_m[1]])


    const base_messages = c_or_m[1]
    const base_corrections = c_or_m[0]
    const nb_last_ignored = pointed_message != null && pointed_message != '' ? disp_matches.filter(m => m.id <= pointed_message).length : 0
    const nb_first_ignored = startDate == null ? disp_matches.length : disp_matches.filter(m => parseInt(m.id) >= startDate).length
    setNbMessages(nb_first_ignored - nb_last_ignored)


  // }
}, [domain_matches, domain_corrections, pointed_message, startDate, last_live_message_id])





const pondered_scale = d3sc.scalePow()
.domain([0, maxThreshold]) // plage de valeurs d'entrée
.range([0, 1]); // plage de valeurs de sortie

function updateNodesQuality() {
  const mmn = m_Nodes.current
  if (! isCoach) {
    return
  }
  
  mmn.map((node) => {
    
            // force a quality attribute to any node = computed pondered similarities
            const searched_id = removeAfterLastUnderscore(node.id.replace(/\s+/g, "_").replace('filler_', '')).toLowerCase()
            let value = 0.2
            let polarity = 'positive'
            try {
              value = currentTargetMessage.current === null ? 0.1 : time_pondered_similarities.current[currentTargetMessage.current][searched_id]
              polarity = currentTargetMessage.current === null ? 'positive' :  polarities.current[currentTargetMessage.current][searched_id]
            } catch (e){
              value = 0.2
            }
            if (value == undefined) {
              value = 0.2
            }

            let quality = 0.2
            if (value > maxThreshold) {
              quality = 1
            } else if (value) { // if (value > minThreshold){
              quality = pondered_scale(value)
            }
            node.polarity = polarity
            node.quality = quality
    })
}


useEffect(() => { // recomputing the displays in the gaph nodes when domain matches are updated
      // Simulate loading of items
        // const call_domain_matches_to_nodes = async () => { 
        //  const res = await domain_matches_to_nodes(m_Nodes.current, disp_matches)
        //  return res
        // }
        m_Nodes.current = mmNodes
        mmNodes.map((n) => {
          if (n.depth > map_max_depth.current) {
            map_max_depth.current = n.depth
            const new_depth_menu_options = max_depth_menu_options.slice(0, map_max_depth.current - 1)
            setDepthList([...new_depth_menu_options])
          }
        })
        const ddom_messages = domain_matches_to_nodes(m_Nodes.current, disp_matches, disp_corrections)
        if (ddom_messages.length > 0){
          setDisp_dom_messages([...ddom_messages])
        } else {
          setDisp_dom_messages([])
        }
        updateNodesQuality()
  }, [mmNodes, disp_matches, disp_corrections, graphDepth, pointed_message, startDate, last_live_message_id])
          
  var nb_past_messages = 0    


  useEffect(() => {

    channel.on('room joined', (roomId, description, parentMessage, point_message, user, mmap) => {

    if (user === 'leaded move') {
      setLeadedMove(true)
    } else {
      setLeadedMove(false)
    }
    if (((user === uid)) || (user === 'leaded move')){
        setMMLinks([])
        setMMNodes([])
        map_max_depth.current = 2
        const new_depth_menu_options = max_depth_menu_options.slice(0, map_max_depth.current - 1)
        setDepthList(new_depth_menu_options)

        nb_past_messages = 0 
        setDomain_matches(new Map())
        setDisp_matches([])
        setDisp_corrections([])
        setDisp_dom_messages([])
        if (point_message) {
          scrollMessages(point_message)
        }
        currentRoomRef.current = roomId
        map_domains.current = []
        // setMMNodes(mmap.nodes) 
        // setMMLinks(mmap.links) 
        console.log('switched to ' + {room} + ' conversation via ' + {roomId} + '.')
  
        // Pour provoquer des ticks manuellement
      } 
     });

    const c_or_m = selectMatchesOrCorrectionsUpTo(pointed_message, domain_matches, domain_corrections)
    setDisp_corrections([...c_or_m[0]])
    setDisp_matches([...c_or_m[1]])

    }, [minThreshold, domain_corrections, maxNbConcepts]);

  useEffect(() =>{
  
     channel.on('creation form fields', (sm) => {
      const m = JSON.parse(sm)
      const user_id = m.user_id
      const m_id = m.m_id
      const roomId = m.currentRoom
      const map_names = m.map_names
      const map_descriptions = m.map_descriptions
      const words = m.t.split(' ')
      const concept = words.splice(-1)
      if ((user_id === uid) && (roomId !== currentRoomRef.current)){
        const form = document.createElement('form');
      
        form.setAttribute('className', 'createConvForm')
        form.setAttribute('id', 'createConv_form')
        // Ajout des champs de saisie
        const textField = document.createElement('input');
        textField.setAttribute('type', 'text');
        textField.setAttribute('name', 'conversation');
        textField.setAttribute('value', concept);
        // textField.textContent(concept)
        form.appendChild(textField);
        const descriptionField = document.createElement('input');
        descriptionField.setAttribute('type', 'text');
        descriptionField.setAttribute('name', 'description');
        descriptionField.setAttribute('value', '..')
        form.appendChild(descriptionField);
      
          // Ajout du champ de saisie menu avec description
      const select = document.createElement('select');
      select.setAttribute('name', 'map_name');

  // Options du menu avec descriptions

      for (let i=0; i < map_names.length; i++) {
        const optionElement = document.createElement('option');
        optionElement.setAttribute('value', map_names[i]);
        optionElement.setAttribute('title', map_descriptions[i]);
        optionElement.textContent = map_names[i];
        select.appendChild(optionElement);
      };

      form.appendChild(select);

      console.log('displaying form')
        // Soumission du formulaire
      const formContainer = document.createElement('div');
      formContainer.classList.add('floating-container');
      formContainer.style.position = 'fixed';
      formContainer.style.top = '100px';
      formContainer.style.left = '10px';
      formContainer.style.backgroundColor = '#fff';
      formContainer.style.padding = '20px';
      formContainer.style.boxShadow = '0 0 20px rgba(0, 0, 0, 0.2)';
    
      const container = document.getElementById('createConv_form');
      if (container != null){
        return
      }
      formContainer.appendChild(form);
      document.body.appendChild(formContainer);

      
        // Ajout du bouton de soumission
        const submitButton = document.createElement('button');
        submitButton.textContent = 'Créer';
        submitButton.addEventListener('click', () => {
        const formData = new FormData(form);
        formData.append('author', user_id)
        formData.append('orig_room',  roomId)
        formData.append('orig_message', m_id)
        const parameters =  Object.fromEntries(formData)        
        channel.emit('create conversation', parameters);
        document.body.removeChild(formContainer)

        });
        form.appendChild(submitButton);

        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Annuler';
        cancelButton.addEventListener('click', () => {
          document.body.removeChild(formContainer)
        });
        form.appendChild(cancelButton);
      }
    });


     channel.on('correction form fields', (sm) => {
      const m = JSON.parse(sm)
      const user_id = m.user_id
      const m_id = m.m_id
      const roomId = m.currentRoom
      const target_node = m.target_node
      const target_path = m.target_path
      const map_root = m.map_root
      let concept = ''
      if (m.concept) {
        const words = m.concept.split(' ')
        concept = words.splice(-1)[0]
      }
      if ((user_id === uid) && (roomId === currentRoomRef.current)){
        const form = document.createElement('form');

        form.setAttribute('class', 'correctionForm')
        form.setAttribute('id', 'correction_form')

        const targetNodeLabel = document.createElement('label')
        targetNodeLabel.textContent = ' Ce message sera projeté sur le noeud: ' + m.target_node;
        form.appendChild(targetNodeLabel);

        const conceptNodeLabel = document.createElement('label')
        conceptNodeLabel.textContent = ' pour le concept: ';
        form.appendChild(conceptNodeLabel);


        // Ajout des champs de saisie
        const textField = document.createElement('input');
        textField.setAttribute('type', 'text');
        textField.setAttribute('name', 'concept');
        textField.setAttribute('value', concept);
        // textField.textContent(concept)
        form.appendChild(textField);

        const strengthNodeLabel = document.createElement('label')
        strengthNodeLabel.textContent = " force de correction: ";
        form.appendChild(strengthNodeLabel);
        const strengthField = document.createElement('input');
        strengthField.setAttribute('type', 'range');
        strengthField.setAttribute('id', 'strength');
        strengthField.setAttribute('name', 'strength');
        strengthField.setAttribute('min', '0');
        strengthField.setAttribute('max', '1');
        strengthField.setAttribute('step', '0.01');
        strengthField.setAttribute('value', '0.75');
        form.appendChild(strengthField);

        const descriptionField = document.createElement('input');
        descriptionField.setAttribute('type', 'text');
        descriptionField.setAttribute('name', 'description');
        descriptionField.setAttribute('value', 'Renseigner la raison de la correction')
        form.appendChild(descriptionField);
      
          // Ajout du champ de saisie menu avec description

      console.log('displaying form')
        // Soumission du formulaire
      const formContainer = document.createElement('div');
      formContainer.classList.add('floating-container');
      formContainer.style.position = 'fixed';
      formContainer.style.top = '100px';
      formContainer.style.left = '50px';
      formContainer.style.backgroundColor = '#fff';
      formContainer.style.padding = '20px';
      formContainer.style.boxShadow = '0 0 20px rgba(0, 0, 0, 0.2)';
    
      const container = document.getElementById('createConv_form');
      if (container != null){
        return
      }
      formContainer.appendChild(form);
      const form_elt = document.getElementById('correction_form');
      if (form_elt === null){
        document.body.appendChild(formContainer);
      }

        const tn = m_Nodes.current.find((n) => removeAfterLastUnderscore(n.id) === removeAfterLastUnderscore(m.target_node))
        if (tn) {
          m.polarity = tn.negative === 'true' ? 'negative' : 'positive'
        }
        // Ajout du bouton de soumission
        const submitButton = document.createElement('button');
        submitButton.textContent = 'Corriger';
        submitButton.addEventListener('click', () => {
        const formData = new FormData(form);
        formData.append('author', user_id)
        formData.append('orig_room',  roomId)
        formData.append('target_node',  target_node)
        formData.append('target_path',  target_path)
        formData.append('map_name',  map_name)
        formData.append('nb_utterances',  '1')
        formData.append('orig_message', m_id)
        formData.append('nickName', m.nickName)
        formData.append('polarity', m.polarity)
        const parameters =  Object.fromEntries(formData)        
        channel.emit('correct message match', parameters);
        document.body.removeChild(formContainer)

        });
        form.appendChild(submitButton);

        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Annuler';
        cancelButton.addEventListener('click', () => {
          document.body.removeChild(formContainer)
        });
        form.appendChild(cancelButton);
      }
    });

     channel.on('mindmap', ((roomId, user, mmap) => {
      if (((user === uid) || user === 'leaded move') /* && (roomId === room ) */){
        setMMLinks(mmap.links) 
        setMMNodes(mmap.nodes)    
      }
    }));

    channel.on('init room messages' , (requesting_room, requesting_uid, mss) => {
      console.log('load initial matches')
     if (currentRoomRef.current != requesting_room) 
        return
      const matches = JSON.parse(mss)
      matches.map((message, i) => {
          if (message.matched_domains !== undefined && message.matched_domains.length > 0) {
            const md = []
            message.matched_domains.map((mdi) => {
              try {
                md.push(JSON.parse(mdi))
              } catch {
                md.push(mdi)
              }
            })
            message.matched_domains = md
          }

          domain_matches.set(message.id, message)
         })
        setDomain_matches(new Map(domain_matches))
    });

    channel.on('domain matches', (matching, roomId) => {
      console.log('got domain matches')
      if (currentRoomRef.current != roomId) 
        return
      const matches = JSON.parse(matching)
      matches.map((message, i) => {
          if (message.matched_domains !== undefined && message.matched_domains.length > 0) {
            const md = []
            message.matched_domains.map((mdi) => {
              try {
                md.push(JSON.parse(mdi))
              } catch {
                md.push(mdi)
              }
            })
            message.matched_domains = md
          }

          domain_matches.set(message.id, message)
         })
        setDomain_matches(new Map(domain_matches))
    });

    channel.on('match corrections', (corrections, roomId) => {
      console.log('got domain corrections')
      if (currentRoomRef.current != roomId) 
        return
      corrections.map((corr, i) => {
          corr.roomId = roomId
         domain_corrections.set(corr.message_id, corr)
         })
        setDomain_corrections(new Map(domain_corrections))
    });
  
    channel.on('map update', (mapid, nodes, links) => {
      m_Nodes.current = mmNodes
      m_Links.current = mmLinks
      const stab_nodes = m_Nodes.current
      const stab_links = m_Links.current
      console.log('update of nodes or links for ' + mapid)
      if ((stab_nodes === undefined) || ((stab_nodes.length > 0 ) && (stab_nodes[0].id !== mapid))){
        return
      }
      nodes.map((node) => {
        if (node === undefined) {
          return false
        }
        // console.log(node.id + ' considered for changing the game.')
        var oldNode = null
        for (let n = 0; n < stab_nodes.length; n +=1) {
          if (n.id === node.id) {
            oldNode = n;
            return
          }
        }
        // const oldNode = mmNodes.find(n => n.id === node.id);
        if (oldNode && hasChanged(node, oldNode)) {
          // console.log(node.id + 'removing first changed node')
          setMMNodes(prevArray => [...prevArray.filter((n) =>  n.id !== node.id), node]
         );
        } else if (!oldNode && (node !== undefined)) {
          // console.log(node.id + ' changing the game.')
          setMMNodes(prevArray => [...prevArray, ...[node]])
        }
        return true
      });
      links.map((link) => {
        const oldLink = stab_links.find((n) => n.id === link.id);
        if (! oldLink) {
            console.log('inserting a new link : ' + link.source + ' -> ' + link.target)
              setMMLinks(prevArray => [...prevArray, {id : link.id, source: link.source, target : link.target}]);
        }
        return true;
      });
      m_Links.current = mmLinks
      m_Nodes.current = mmNodes
    }, 300);
  }, []);


  const handleSelectFormat = (format) => {
            setGraphFormat(format)
          };
          
  const handleSelectDepth = (format) => {
            setGraphDepth(format)
        }          

  const rollFormatOptions = (direction) => {
            if (direction === 'right') {
              setFormatList((prevList) => {
                return [...prevList.slice(1), prevList[0]]
              }) 
            } else if (direction === 'left') {
              setFormatList((prevList) => {
                return [...prevList.slice(-1), ...prevList.slice(0, -1)]
              }) 
            }
          }
          
          const handleFormatScroll = (event) => {
            // Exemple de gestion de l'événement de défilement
            if (event.deltaY > 0) {
              rollFormatOptions('right')
            } else {
              rollFormatOptions('left')
            }
          };
         
          const rollDepthOptions = (direction) => {
            if (direction === 'right') {
              setDepthList([...depthList.slice(1), depthList[0]])
            } else if (direction === 'left') {
              setDepthList([...depthList.slice(-1), ...depthList.slice(0, -1)])
            }
          }
          
          const handleDepthScroll = (event) => {
            // Exemple de gestion de l'événement de défilement
            if (event.deltaY > 0) {
              rollDepthOptions('right')
            } else {
              rollDepthOptions('left')
            }
          };
          
  return (
    <div>
    <div  className='horizontal-carousel-header' id='graph-display-menus'>
      {/*
     <div className="horizontal-carousel" id='graph_format_menu'>
       <button className="horizontal-carousel-button" scale='.6' border-radius='10%' max-height='1px' onClick={() => rollFormatOptions('left')}>&#x25C0;</button>
    <div className="options-container" onWheel={handleFormatScroll}>
      {formatList.slice(0, 3).map((option, index) => (
        <div
          key={option}
          className={`roomlist_option ${option === graphFormat ? 'active' : ''}`}
          onClick={() => handleSelectFormat(option)}
        >
          {option}
        </div>
      ))}
      </div>
      <button className="horizontal-carousel-button" scale='.6' border-radius='10%' onClick={() => rollFormatOptions('right')}>&#x25B6;</button> 
      </div>
    */}
      <div className="horizontal-carousel" id='graph_depth_menu'>
       <button className="horizontal-carousel-button" scale='.6' border-radius='10%' max-height='1px' 
       onClick={() => rollDepthOptions('left')}>&#x25C0;</button>
      <div className="options-container no-select" onWheel={handleDepthScroll}>
      {depthList.slice(0, 3).map((option, index) => (
        <div
          key={option}
          className={`depthlist_option no-select ${option === graphDepth ? 'active' : ''}`}
          onClick={() => handleSelectDepth(option)}
        >
                  {
          (option === 'Carte')? (
            <ImageButton
              url={`${protocol}://${server_host}:3050/images/activity.svg`} onClick={() => handleSelectDepth(option)} title={'Le terrain à découvrir, les régions à explorer'}/>
          ) : 
          (option === 'POI')? (
            <ImageButton
              url={`${protocol}://${server_host}:3050/images/sun.svg`} onClick={() => handleSelectDepth(option)} title={'Les points d\'intéret, ce que vous pouvez rencontrer dans vos explorations'}/>
            ) : 
            (option === 'Observation')? (
              <ImageButton
                url={`${protocol}://${server_host}:3050/images/eye.svg`} onClick={() => handleSelectDepth(option)} title={'La contingence de la situation : ce que vous percevez des conditions, ce qui vous semble particulier'}/>
              ) : 
              (option === 'Capteurs')? (
                <ImageButton
                  url={`${protocol}://${server_host}:3050/images/circle.svg`} onClick={() => handleSelectDepth(option)} title={'La perception peut parfois se confirmer par une mesure, ou par une échelle d\'intensité'}/>
              ) : (' gnu ')
        }
          {option}
        </div>
      ))}
      </div>
      <button className="horizontal-carousel-button" scale='.6' border-radius='10%' onClick={() => rollDepthOptions('right')}>&#x25B6;</button> 
      </div>
      </div>
      { /* (graphDepth === 'Observation') && */ 
      
      <div className="qual_precision">
      {/* Inputs pour ajuster les seuils */}
      <input
        className='range_input'
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={minThreshold}
        onChange={handleMinThresholdChange}
      /> exigence : {minThreshold}  . . .  marques  : {[1, 2, 3, 5, 10, 30].map((value) => (
        <button
          key={value}
          type="button"
          className={maxNbConcepts === value ? 'maxNbConceptsSelection selected' : 'maxNbConceptsSelection'}
          aria-pressed={maxNbConcepts === value}
          onClick={() => setMaxNbConcepts(value)}
        >
          {value}
        </button>
      ))}

      {/*
      <input
        class='range_input'
        type="range"
        min="0"
        max="1"
        step="0.001"
        value={maxThreshold}
        onChange={handleMaxThresholdChange}
      />
      */}
    </div>}




      {/*(graphFormat === 'H') && <HorizontalTreeGraph room={currentRoom} mmNodes={mmNodes}
                    scrollMessages={scrollMessages}
                    disp_dom_messages={disp_dom_messages}  time_pondered_similarities={time_pondered_similarities}
                    domain_matches={domain_matches} graphDepth={graphDepth} />*/}
       {/*(graphFormat === 'V') && <VerticalTreeGraph room={currentRoom} mmNodes={mmNodes}
                    scrollMessages={scrollMessages}
                    disp_dom_messages={disp_dom_messages}  time_pondered_similarities={time_pondered_similarities}
                    domain_matches={domain_matches} graphDepth={graphDepth} />*/}
        {(graphFormat === '@') && <RadialGraph room={currentRoomRef.current} mmNodes={mmNodes} graphRatio={graphRatio}
                    graphWidth={graphWidth} graphHeight={graphHeight} scrollMessages={scrollMessages}  request_a_form={request_a_form}
                    request_a_correction={request_a_correction} disp_dom_messages={disp_dom_messages}
                    nb_messages={nb_messages} domain_matches={domain_matches} graphDepth={graphDepth} isMobile={isMobile}
                     hideTooltipWhenOut={hideTooltipWhenOut}/>}
                    
        {/*(graphFormat === '*') && <SunburstGraph uid={uid} sroom={currentRoom} mmNodes={mmNodes}
                    scrollMessages={scrollMessages}
                    disp_dom_messages={disp_dom_messages}  time_pondered_similarities={time_pondered_similarities}
                    domain_matches={domain_matches} graphDepth={graphDepth}/>*/}
        {/*(graphFormat === 'HMap') && <HorizontalTreeMap uid={uid} sroom={currentRoom} mmNodes={mmNodes} 
                    scrollMessages={scrollMessages}
                    disp_dom_messages={disp_dom_messages}  time_pondered_similarities={time_pondered_similarities}
                    domain_matches={domain_matches} graphDepth={graphDepth}/>*/}
        {/*(graphFormat === 'VMap') && <VerticalTreeMap uid={uid} sroom={currentRoom} mmNodes={mmNodes} 
                    scrollMessages={scrollMessages}
                    disp_dom_messages={disp_dom_messages}  time_pondered_similarities={time_pondered_similarities}
                    domain_matches={domain_matches} graphDepth={graphDepth}/>*/}
        {/*(graphFormat === '->') && <ForceDirectedGraph uid={uid} sroom={currentRoom} mmNodes={mmNodes} 
                    scrollMessages={scrollMessages}
                    disp_dom_messages={disp_dom_messages}  time_pondered_similarities={time_pondered_similarities}
                    domain_matches={domain_matches} graphDepth={graphDepth}/>*/}

        {<TimelineWithMiniMap domain_matches={domain_matches} 
                corrections={disp_corrections}
                currentRoom={currentRoomRef.current}
                startDate={startDate}
                setStartDate={setStartDate}
                scrollMessages={scrollMessages} username={username} 
                polarities={polarities.current} 
                pointed_message={pointed_message} threshold={minThreshold}
                map_domains={map_domains.current.sort()} />}
                </div>
  );

}

export default Graph;